import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Table,
  Breadcrumb,
  Modal,
  Button,
  Spin,
  message,
  Input,
  Menu,
  Select,
  Tooltip,
} from 'antd';
import { MessageDialog } from 'Components/dialogs/index'
import intl from 'react-intl-universal';
import cuid from 'cuid';
import './Drives.scss';
import './Drives.panel.scss';
import './Drives.mobile.scss';
// import EventEmitter from 'eventemitter3';
import { driveIconSize } from 'Components/common_ui.constant';
import googleDriveIcon from '../../assets/drives/Google_Drive_logo.svg';
import oneDriveIcon from '../../assets/drives/apps-suite-icon-onedrive.svg';
import boxIcon from '../../assets/drives/box-blue.svg';
import dropBoxIcon from '../../assets/drives/dropbox-logo.svg';
import IManageIcon from '../../assets/IManage/imanage_login_icon.svg'
import refreshBtnIcon from '../../assets/drives/refresh.svg';
import { store } from 'Store/store.index';
import { convertController, fileController } from 'Components/viewer/Controllers/index';
import {
  handlerFileNameWithoutExtension,
  convertFileSizeToKBSize,
  storageGetItem,
  storageSetItem,
  getFileNameWithoutExtension,
  getExtensionByFileName,
  isCanvas,
  saveNeedReLoginDrive,
} from 'Utils/utils';
import { signOut } from 'Api/drives.api';
import { DATA_TYPE, FileData, TASK_STATUS } from 'Api/index';
import { SUPPORT_FILE_EXTENSIONS_MAP, driveNameTokenNameMap, getFileNameAndExtensionByMIMEType, isValidFileName } from 'Api/drives.constants'
import DocIcon from '../../assets/drives/document.svg'
import FolderIcon from '../../assets/drives/folder.svg'
import FileIcon from '../../assets/drives/file-icon.svg'
import { GOOGLE_DRIVE, /* ONE_DRIVE, BOX, DROP_BOX */ } from 'Api/drives.constants';
import { getFileBufferByUrl } from 'Api/index';
import {
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
} from "../viewer/ui/constants/convert.constants";
import { isMobile, isTeamsApp } from 'Utils/device';
import { DRIVES_FILE_SIZE_LIMIT } from '@/limit.constant';
import { drivesService, iManageService, localToGlobal } from '@/store/services/index';
import { iManage } from '@api/drives.constants'
import { DRIVE_DLG_TYPE_SAVE_AS } from '@/store/constants';

// let countClick = 0;
// let hClick = null;
// let vCurrentKey = '';
let docName = '';
const { Option } = Select;

@inject('driveStore')
@observer
class Drives extends React.Component {
  constructor(props) {
    super(props);
    this.iManageFrameRef = React.createRef()
    this.Cancel = intl.formatMessage({ id: 'Cancel' });
    this.Open = intl.formatMessage({ id: 'Open' });
    this.Save = intl.formatMessage({ id: 'Save' });
    this.AddFile = intl.formatMessage({ id: 'Add' });
    this.Ok = intl.formatMessage({ id: 'Ok' });
    this.AddFilesSuccess = intl.formatMessage({ id: 'CombineFiles.Msg.AddFilesSuccess' });
    this.SingleFileSizeOver = intl.formatMessage({ id: 'CombineFiles.Msg.SingleFileSizeOver' });
    this.FileName = intl.formatMessage({ id: 'SaveFileForPanel.Modal.FileName' });
    this.FileType = intl.formatMessage({ id: 'SaveFileForPanel.Modal.FileType' });
    this.FileNameRequire = intl.formatMessage({ id: 'PrivateDrive.FileNameRequire' });
    this.SpecialCharacters = intl.formatMessage({ id: 'SaveFileForPanel.Modal.SpecialCharacters' });

    this.defaultModalContentHeight = '377px';
    this.signInSaveModalContentHeight = '400px';
    this.signInOpenModalContentHeight = '481px';
    this.defaultModalContentHeightForMobile = `${window.innerHeight - 118}px`;
    this.signInSaveModalContentHeightForMobile = `${window.innerHeight - 270}px`;
    this.signInOpenModalContentHeightForMobile = `${window.innerHeight - 171}px`;
    this.showFolderNum = 4;
    this.tempFolderArr = this.getTempFolderArr();
    this.cache = {};
    this.state = {
      iManageFilePickerUrl: null,
      newFolderName: intl.get('SaveFileForPanel.Modal.defaultNewFolderName'),
      filesData: [],
      folderPath: this.getFolderPath(),
      loadingDocBuffer: false,
      driveModalContentHeight: this.defaultModalContentHeight,
      isSignIn: false,
      userInfo: {},
      numberOfAjaxCAllPending: 0,
      selectedRowKeys: [],
      selectedRows: [],
      activeRow: {},
      selectedFileType: 'AllFiles',
      currentDriveTokenInfo: [],
      selectedUser: {},
      messageDlgCfg: {},
      isShowMessageDlg: false,
      fileType: 1,
      isUseGoogleFormat: true,
      uploading:false
    };

    this.createFolderPath = this.createFolderPath.bind(this);
    this.openFolderFromPath = this.openFolderFromPath.bind(this);
    this.authorization = this.authorization.bind(this);
    this.signOut = this.signOut.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.createDriveIcon = this.createDriveIcon.bind(this);
    this.cancelDrivesModal = this.cancelDrivesModal.bind(this);
    this.createTableColumn = this.createTableColumn.bind(this);
    this.refreshFolder = this.refreshFolder.bind(this);
    this.getSaveFileInputPanel = this.getSaveFileInputPanel.bind(this);
    this.onSaveFile = this.onSaveFile.bind(this);
    this.doSaveFile = this.doSaveFile.bind(this);
    this.doSaveFileShortcut = this.doSaveFileShortcut.bind(this);
    this.getFocusFileName = this.getFocusFileName.bind(this);
    this.clickOrDoubleClick = this.clickOrDoubleClick.bind(this);
    this.doUpdateFile = this.doUpdateFile.bind(this);
    this.getCurrentPDFBlob = this.getCurrentPDFBlob.bind(this);
    this.handleFolderPathOverLen = this.handleFolderPathOverLen.bind(this);
    this.getAllFolderPath = this.getAllFolderPath.bind(this);
    this.openFolderFromPathForMobile = this.openFolderFromPathForMobile.bind(this);
    this.createFolderPathForMobile = this.createFolderPathForMobile.bind(this);
    this.openFolderForMobile = this.openFolderForMobile.bind(this);
    this.revokeToken = this.revokeToken.bind(this);
    this.getDriveModalContentHeight = this.getDriveModalContentHeight.bind(this);
    this.numberOfAjaxCAllPendingIncrease = this.numberOfAjaxCAllPendingIncrease.bind(this);
    this.numberOfAjaxCAllPendingDecrease = this.numberOfAjaxCAllPendingDecrease.bind(this);
    this.resetNumberOfAjaxCAllPending = this.resetNumberOfAjaxCAllPending.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.getPanelTypeFooterBtnWrapper = this.getPanelTypeFooterBtnWrapper.bind(this);
    this.onAddFiles = this.onAddFiles.bind(this);
    this.onOpen = this.onOpen.bind(this);
    
    store.driveStore.setOnSaveFileByMyself(this.onSaveFileByMyself)
    store.driveStore.setOnAddFilesForAddPanel(this.onAddFiles)
    store.driveStore.setNumberOfAjaxCAllPendingIncrease(this.numberOfAjaxCAllPendingIncrease)
    store.driveStore.setNumberOfAjaxCAllPendingDecrease(this.numberOfAjaxCAllPendingDecrease)
    store.driveStore.setResetNumberOfAjaxCAllPending(this.resetNumberOfAjaxCAllPending)
    
    localToGlobal.setDoSaveFile(this.doSaveFile)
  }
  getDriveModalContentHeight() {
    if (this.state.isSignIn === true) {
      if (isMobile) {
        this.props.operateType === 'open' && this.setState({ driveModalContentHeight: this.signInOpenModalContentHeightForMobile });
        this.props.operateType === 'save' && this.setState({ driveModalContentHeight: this.signInSaveModalContentHeightForMobile });
      } else {
        this.props.operateType === 'open' && this.setState({ driveModalContentHeight: this.signInOpenModalContentHeight });
        this.props.operateType === 'save' && this.setState({ driveModalContentHeight: this.signInSaveModalContentHeight });
      }
    } else {
      if (isMobile) {
        this.setState({ driveModalContentHeight: this.defaultModalContentHeightForMobile });
      } else {
        this.setState({ driveModalContentHeight: this.defaultModalContentHeight });
      }
    }
  }
  revokeToken() {
    signOut(this.props.driveName);
  }
  onChangeNewFolderName = ({target: { value}}) => {
    this.setState({
      newFolderName: value
    })
  }
  createFolder = () => {
    store.appStore.onShowWarningMessage(async (isOkBtn) => {
      const { driveName } = this.props
      const { folderPath, newFolderName: folderName } = this.state

      if (isOkBtn) {
        try {
          let res = await store.driveStore.doCreateFolder({ driveName, folderName, folderPath })

          // 处理box名称冲突时无法自动重命名的问题
          if (res === 'name exist') {
            store.appStore.setGlobalMessage({type: 'error', content: intl.get('SaveFileForPanel.Modal.FolderNameExist')})

            return
          }

          if (driveName === 'DropBox' && res && res.metadata) {
            res = res.metadata
          }

          this.setState({
            filesData: [Object.assign(res, { isFolder: true, size: '' }), ...this.state.filesData]
          })
        } catch (error) {
          throw new Error(error)
        }
      }
    }, {
      title: 'SaveFileForPanel.Modal.NewFolder',
      containerClass: "drives-create-folder-dlg",
      contentComponent: <Input type="text" onChange={this.onChangeNewFolderName} defaultValue={this.state.newFolderName} />,
      iconType: null,
    })
  }
  // TODO: replace  => rowSelection, onRow
  clickOrDoubleClick(record) {
    const { operateType } = this.props;
    // const {activeRow} = this.state;
    const { openFileDlg: { isForAi } } = store.appStore;
    // let key = !!activeRow? activeRow.id:'';
    // let currentKey = record.id;
    // // let lastKey = vCurrentKey;
    // // clean last timeout callback
    // if(hClick && vCurrentKey && vCurrentKey !== currentKey){

    //   hClick && clearTimeout(hClick);
    //   countClick = 0;
    //   hClick = null;
    // }
    // vCurrentKey = currentKey;

    // if(key && (key !== currentKey)){
    //   countClick = 0;
    // }
    // countClick += 1;
    // if(countClick>2)countClick=2;


    // hClick = setTimeout(() => {
    //   clearTimeout(hClick);
    //   hClick = null;
    //   if (countClick === 1) {
    //     if (operateType === 'save' && !record.isFolder) {
    //       this.getFocusFileName(record);
    //     }
    //     if (operateType === 'open') {
    //       this.setState(
    //         {
    //           activeRow: record,
    //         },
    //         () => {
    //           let h = setTimeout(()=>{
    //             clearTimeout(h);
    //             document.querySelectorAll('.drives-content-wrapper .ant-table-row').forEach((item) => {
    //               item.style.background = 'none';
    //             });
    //             let node = document.querySelector('.drives-content-wrapper .activeRow.ant-table-row-cell-ellipsis');
    //             if(!node || !node.parentElement || !node.parentElement.parentElement){
    //               //
    //               console.error("Drives -> clickOrDoubleClick -> node is missing")
    //               return;
    //             }
    //             node.parentElement.parentElement.style.background = '#f8eef8';
    //           },10);
    //         },
    //       );
    //       //setTimeout(() => {});
    //     }
    //   } else if (countClick === 2) {
    if (operateType === 'open') {
    store.docStore.setDocDriveName(this.props.driveName)

      const { isFolder } = record;

      if (isFolder) {
        this.openFolder(record);
      } else {
        if (isForAi) {
          this.doUploadFileForAi(record)
        } else {
          this.downloadFile(record);
        }
      }
    } else if (operateType === 'save') {
      const { isFolder } = record;

      if (isFolder) {
        this.openFolder(record);
      } else {
        this.doSaveFileShortcut(record);
      }
    } else if (operateType === 'add') {
      const { isFolder } = record;

      if (isFolder) {
        this.openFolder(record);
      }
    }
    // operateType === 'open' && this.downloadFile(record);
    // operateType === 'save' && this.doSaveFileShortcut(record);
    //   }
    //   countClick = 0;
    //   vCurrentKey = '';
    // }, 300);
  }
  getFocusFileName(record) {
    const { setFieldsValue } = this.props.form;

    setFieldsValue({
      filename: record.name,
    });
  }
  doSaveFileShortcut(record) {
    const messageDlgCfg = Object.assign({}, this.state.messageDlgCfg, {
      msg: { id: 'Private.duplicateFileNameContent', messageParams: { FileName: record.name }, title: 'Private.duplicateFileNameTitle' },
      onOk: () => {
        const { driveName } = this.props;

        (driveName !== 'Google Drive' && driveName !== 'Box') ? this.doSaveFile(record.name) : this.doUpdateFile(record,(result)=>{
          if(result != 'success'){
            store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'UploadingFile.fail' }) });
          }else{
            store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'UploadingFile.success' }) });
            store.docStore.setDocDriveName(this.props.driveName);
          }
        });
        this.setState({
          isShowMessageDlg: false,
        })
      },
      onClose: () => {
        this.setState({
          isShowMessageDlg: false,
        })
      }
    });

    this.setState({
      isShowMessageDlg: true,
      messageDlgCfg,
    })
  }
  handleFilterFileType = (selectedFileType, confirm) => {
    confirm();
    this.setState({
      selectedFileType,
    })
  }

  getColumnSearchProps = dataIndex => {
    const { selectedFileType } = this.state
    const AllFiles = intl.get('OpenFileForPanel.Modal.AllFiles');
    const Word = intl.get('OpenFileForPanel.Modal.Word');
    const Excel = intl.get('OpenFileForPanel.Modal.Excel');
    const PPT = intl.get('OpenFileForPanel.Modal.PPT');
    const Visio = intl.get('OpenFileForPanel.Modal.Visio');
    const ImageFiles = intl.get('OpenFileForPanel.Modal.ImageFiles');
    const Html = intl.get('OpenFileForPanel.Modal.Html');
    const PDF = intl.get('OpenFileForPanel.Modal.PDF');
    const WPS = intl.get('OpenFileForPanel.Modal.WPS');
    const HanWord = intl.get('OpenFileForPanel.Modal.HanWord');
    const TXT = intl.get('OpenFileForPanel.Modal.TXT');
    const fileTypeArr = [
      { value: 'AllFiles', text: AllFiles },
      { value: 'PDF', text: PDF },
      { value: 'Word', text: Word },
      { value: 'Excel', text: Excel },
      { value: 'PPT', text: PPT },
      { value: 'Visio', text: Visio },
      { value: 'TXT', text: TXT },
      { value: 'ImageFiles', text: ImageFiles },
      { value: 'Html', text: Html },
      { value: 'WPS', text: WPS },
      { value: 'HanWord', text: HanWord },
    ];
    return {
      filterDropdown: ({ confirm }) => (
        <div className="drive-file-type-filter" style={{ padding: 8, cursor: 'pointer' }}>
          {
            fileTypeArr.map((item, index) => {
              return <div className={`file-type-item ${selectedFileType === item.value ? 'active' : ''}`} key={index} value={item.value} onClick={() => this.handleFilterFileType(item.value, confirm, dataIndex)}>{item.text}</div>
            }
            )
          }
        </div>
      ),
      filterIcon: filtered => (
        <FilterOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        // <Icon type="filter" />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      // onFilterDropdownVisibleChange: visible => {
      //   if (visible) {
      //     setTimeout(() => this.searchInput.select());
      //   }
      // },
      // render: text =>
      //   this.state.searchedColumn === dataIndex ? (
      //     <Highlighter
      //       highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
      //       searchWords={[this.state.searchText]}
      //       autoEscape
      //       textToHighlight={text.toString()}
      //     />
      //   ) : (
      //     text
      //   ),
    };
  };
  createTableColumn() {
    const name = intl.formatMessage({ id: 'FileName' });
    const size = intl.formatMessage({ id: 'FileSize' });
    const modifyTime = intl.formatMessage({ id: 'ModifyTime' });

    return !isMobile
      ? [
        {
          title: name,
          dataIndex: 'name',
          width: 256,
          ellipsis: true,
          ...this.getColumnSearchProps('name'),
          // filterIcon: (filtered) => (
          //   <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
          //   // <i className="filter-btn"></i>
          // ),
          // filters: [
          //   {
          //     text: 'PDF',
          //     value: 'pdf'
          //   }
          // ],
          // onFilter: (value, record) => record.name.includes(value),
          render: (text, record) => {
            return (
              <React.Fragment>
                {record.isFolder && (
                  <div
                    // className="ant-table-row-cell-ellipsis"
                    className={`${this.state.activeRow.id === record.id ? 'activeRow' : ''} ant-table-row-cell-ellipsis`}
                    style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
                    // onDoubleClick={this.openFolder.bind(this, record)}>
                    onClick={this.clickOrDoubleClick.bind(this, record)}>
                    <img src={FolderIcon} alt="folder" width="16px" style={{ marginRight: '10px' }} />
                    {text}
                  </div>
                )}
                {!record.isFolder && (
                  <div
                    // className="ant-table-row-cell-ellipsis"
                    className={`${this.state.activeRow.id === record.id ? 'activeRow' : ''} ant-table-row-cell-ellipsis`}
                    // ref={this.state.activeRow.id === record.id ? 'activeRow' : null}
                    style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
                    onClick={this.clickOrDoubleClick.bind(this, record)}>
                    <img
                      src={FileIcon}
                      alt="document"
                      width="16px"
                      style={{ marginRight: '10px', marginLeft: '2px' }}
                    />
                    {text}
                  </div>
                )}
              </React.Fragment>
            );
          },
        },
        {
          title: size,
          dataIndex: 'size',
          width: 100,
          ellipsis: true,
          // defaultSortOrder: 'descend',
          sorter: (a, b) => {
            if (a.isFolder || b.isFolder) {
              return 0
            }

            return convertFileSizeToKBSize(a.size) - convertFileSizeToKBSize(b.size)
          },
        },
        {
          // created_at: "2019-10-29T18:39:01-07:00"
          // etag: "0"
          // id: "91662974298"
          // modified_at: "2020-02-25T18:55:31-08:00"
          // name: "Documents"
          // size: 586632
          // type: "folder"
          title: modifyTime,
          dataIndex: 'modifiedTime',
          ellipsis: true,
          sorter: (a, b) => {
            if (a.isFolder || b.isFolder) {
              return 0
            }

            return new Date(a.modifiedTime) - new Date(b.modifiedTime)
          },
        },
      ]
      : [
        {
          title: name,
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
          render: (text, record) => {
            return (
              <React.Fragment>
                {record.isFolder && (
                  <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }} onClick={this.openFolderForMobile.bind(this, record)}>
                    <img src={FolderIcon} alt="folder" width="19px" style={{ marginRight: '10px' }} />
                    {/* <Icon type="folder" theme="twoTone" twoToneColor="#E373E7" /> */}
                    {text}
                  </div>
                )}
                {!record.isFolder && (
                  <div style={{ wordWrap: 'break-word', wordBreak: 'break-word', display: 'flex' }} onClick={this.clickOrDoubleClick.bind(this, record)}>
                    <img src={DocIcon} alt="document" width="14px" style={{ marginRight: '10px', marginLeft: '2px' }} />
                    <div className="ant-table-row-cell-ellipsis">
                      <div className="file-name-mobile">{text}</div>
                      <div className="font-gray-mobile">{record.modifiedTime}</div>
                    </div>
                    {/* <Icon type="file-text" /> */}
                    {/* {text} */}
                  </div>
                )}
              </React.Fragment>
            );
          },
        },
        {
          title: size,
          dataIndex: 'size',
          ellipsis: true,
          render: (text, /* record */) => {
            return (
              <React.Fragment>
                <span className="font-gray-mobile">{text}</span>
              </React.Fragment>
            );
          },
        },
        // {
        //   title: modifyTime,
        //   dataIndex: 'modifiedTime',
        // },
      ];
  }
  numberOfAjaxCAllPendingIncrease() {
    this.setState((state) => ({
      numberOfAjaxCAllPending: state.numberOfAjaxCAllPending + 1,
    }));
  }
  numberOfAjaxCAllPendingDecrease() {
    this.setState((state) => ({
      numberOfAjaxCAllPending: state.numberOfAjaxCAllPending - 1,
    }));
  }
  resetNumberOfAjaxCAllPending() {
    this.setState({
      numberOfAjaxCAllPending: 0,
    });
  }
  downloadFile(item) {
    const { type } = this.props;

    this.numberOfAjaxCAllPendingIncrease();
    
    const chunk = 1 * 1024 * 1024;
    const docSize = item.originSize;
    const mimeType = item.file && item.file.mimeType;
    const driveName = this.props.driveName;
    // 大文档分片下载
    if ((driveName === 'OneDrive') && (mimeType === 'application/pdf') && (docSize > chunk)) {
      const downloadUrl = item['@microsoft.graph.downloadUrl'];
      const fileName = item.name;
      const ab = new ArrayBuffer(docSize);
      const blob = new Blob([ab]);
      const file = new window.File([blob], docName, { type: 'application/pdf' });
      const PDFUI = store.viewer.pdfui;
      
      this.numberOfAjaxCAllPendingDecrease();
      type === 'panel' && this.props.onCancel();
      type === 'modal' && this.props.cancelModal();

      return PDFUI.openPDFByFile(file, { 
        fileName: fileName,
        ReadBlockOption: {
          url: downloadUrl,
          chunk
        }
      })
    }

    store.driveStore.doOpenFile(
      this.props.driveName,
      item,
      ({ blob, id, fileName }) => {
        if (!isValidFileName(fileName)) {
          fileName = getFileNameAndExtensionByMIMEType(getFileNameWithoutExtension(fileName), blob.type)
        }
        
        blob.name = fileName

        if (blob.type === 'application/pdf' || /(.pdf)$/.test(fileName)) {
          this.props.openFileCallback &&
            this.props.openFileCallback({ driveName: this.props.driveName, blob, id, fileName, folderPath: this.state.folderPath, item });
        } else {
          convertController.doConvertToPDF(
            blob,
            (result) => {
              if (result && result != 'stop' && result.ret == 0 && result.url) {
                const { url, fileName } = result;
                fileController.doOpenFileByUrl(url, fileName, (err) => {
                  console.error("onHandlePDFByResponse -> err", err)
                });
                return;
              }
            },
            (/*err*/) => { },
            true
          );
        }

        type === 'panel' && this.props.onCancel();
        type === 'modal' && this.props.cancelModal();
        this.numberOfAjaxCAllPendingDecrease();
      },
      ({ error }) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);

        if (this.props.driveName === 'DropBox' && error && error.status === 409) {
          message.error(intl.get('RestrictDownload'));
        }
      },
    );
  }

  openFolder(folder) {
    const { driveName } = this.props

    drivesService.updateOpenedFolder({ [driveName]: folder })
    this.setState({
      activeRow: {},
      selectedRowKeys: [],
      selectedRows: [],
    })
    this.numberOfAjaxCAllPendingIncrease();
    store.driveStore.doGetItems({
      driveName,
      folderId: folder.id,
      success: (res) => {
        this.numberOfAjaxCAllPendingDecrease();

        this.setState({
          filesData: res.result.files,
        });
        this.getAllFolderPath();
        this.setState((state) => ({
          folderPath: [...state.folderPath, folder],
        }));
        drivesService.updateFolderPath({ [driveName]: this.state.folderPath })
        this.handleFolderPathOverLen();
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
      },
    });
  }
  openFolderForMobile(folder) {
    const { driveName } = this.props

    drivesService.updateOpenedFolder({ [driveName]: folder })
    this.numberOfAjaxCAllPendingIncrease();
    store.driveStore.doGetItems({
      driveName,
      folderId: folder.id,
      success: (res) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.setState({
          filesData: res.result.files,
        });
        this.setState((state) => ({
          folderPath: [...state.folderPath, folder],
        }));
        drivesService.updateFolderPath({ [driveName]: this.state.folderPath })
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
      },
    });
  }
  refreshFolder(folder, callback) {
    // 外部插件增加强制刷新的标记,由外部插件自行决定是否强制刷新.
    store.netDriverStore.SetDriverReloadFlag(this.props.driveName,true)
    this.numberOfAjaxCAllPendingIncrease();
    store.driveStore.doGetItems({
      driveName: this.props.driveName,
      folderId: folder.id,
      success: (res) => {
        this.numberOfAjaxCAllPendingDecrease();

        this.setState({
          filesData: res.result.files,
        });

        callback && callback();
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
      },
    });
  }

  openFolderFromPath(folder, /* index */) {
    const { driveName } = this.props

    this.numberOfAjaxCAllPendingIncrease();
    store.driveStore.doGetItems({
      driveName,
      folderId: folder.id,
      success: (res) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.setState({
          filesData: res.result.files,
        });

        let targetIndex;

        this.getAllFolderPath();
        this.state.folderPath.forEach((item, index) => {
          if (item.id === folder.id) {
            targetIndex = index;
          }
        });
        this.setState((state) => ({
          folderPath: state.folderPath.slice(0, targetIndex + 1),
        }));
        drivesService.updateOpenedFolder({ [driveName]: folder })
        drivesService.updateFolderPath({ [driveName]: this.state.folderPath })
        this.handleFolderPathOverLen();
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
      },
    });
  }
  openFolderFromPathForMobile(folder, index) {
    const { driveName } = this.props

    this.numberOfAjaxCAllPendingIncrease();

    store.driveStore.doGetItems({
      driveName,
      folderId: folder.id,
      success: (res) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.setState({
          filesData: res.result.files,
        });
        this.setState((state) => ({
          folderPath: state.folderPath.slice(0, index + 1),
        }));
        drivesService.updateOpenedFolder({ [driveName]: folder })
        drivesService.updateFolderPath({ [driveName]: this.state.folderPath })
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
      },
    });
  }

  signOut() {
    store.driveStore.doSignOut(this.props.driveName, () => {
      if (!this.isIManage()) {
        const { selectedUser } = this.state;
  
        this.doDeleteUserToken(selectedUser);
        this.setState(
          {
            isSignIn: false,
            filesData: [],
            userInfo: {},
          },
          () => {
            this.getDriveModalContentHeight();
          },
        );
      } else {
        this.setState({
          isSignIn: false
        },
        () => {
          this.getDriveModalContentHeight();
        })
      }
    });
  }

  authorization() {
    const { driveName } = this.props

    // Cannot use Drive within Microsoft Teams desktop.
    if (isTeamsApp) {
      this.setState({
        isShowMessageDlg: true,
        messageDlgCfg: {
          msg: {
            id: 'DrivesListDlg.OnTeamsTips',
            messageParams: { name: this.props.driveName },
            closable: true,
            checkbox: null,
            iconType: 'warning',
            noCancel: true
          },
          onOk: () => {
            this.setState({
              isShowMessageDlg: false,
            })
          },
          onClose: () => {
            this.setState({
              isShowMessageDlg: false,
            })
          }
        }
      })
      return;
    }

    if (this.isIManage()) {
      this.numberOfAjaxCAllPendingIncrease();
      store.driveStore.doAuthorization({
        driveName: this.props.driveName,
        success: (filePickerUrl) => {
          this.setState({
            isSignIn: true,
            iManageFilePickerUrl: filePickerUrl
          });
        },
        fail: (error) => {
          this.resetNumberOfAjaxCAllPending();
          this.errorHandler(error);
        },
        closeWin: () => {
          this.resetNumberOfAjaxCAllPending();
        }
      })

      return;
    }
    
    this.numberOfAjaxCAllPendingIncrease();
    store.driveStore.doAuthorization({
      driveName: this.props.driveName,
      success: () => {
        // this.numberOfAjaxCAllPendingDecrease();
        this.setState({
          isSignIn: true,
        });

        if(isCanvas()){
          saveNeedReLoginDrive(false);
          if(localStorage.getItem('only-sign-in-drive')==='1'){
            store.appStore.emitEvent('close-lms-file-dlg');
            localStorage.setItem('only-sign-in-drive','0');
          }
        }

        this.getDriveModalContentHeight();

        this.numberOfAjaxCAllPendingIncrease();
        store.driveStore.doGetUserInfo({
          driveName,
          success: (res) => {
            this.numberOfAjaxCAllPendingDecrease();
            this.setDriveTokenInfo()
            this.setState({
              userInfo: res,
              selectedUser: {
                userAccount: res.userAccount,
                accessToken: res.accessToken
              }
            });
            this.numberOfAjaxCAllPendingIncrease();
            store.driveStore.doGetItems({
              driveName,
              folderId: null,
              success: (res) => {
                this.resetNumberOfAjaxCAllPending()
                this.setState({
                  filesData: res.result.files,
                });

                drivesService.updateFolderDataForChangeUser(driveName)
                
                const folderPath = this.getFolderPath()
                
                this.setState({
                  folderPath
                })
                this.tempFolderArr = this.getTempFolderArr()
              },
              fail: (error) => {
                this.resetNumberOfAjaxCAllPending()
                this.errorHandler(error);
              },
            });
          },
          fail: (error) => {
            this.numberOfAjaxCAllPendingDecrease();
            this.errorHandler(error);
          },
        });

        // this.numberOfAjaxCAllPendingIncrease();
        // store.driveStore.doGetItems({
        //   driveName: this.props.driveName,
        //   folderId: null,
        //   success: (res) => {
        //     this.numberOfAjaxCAllPendingDecrease();
        //     this.setState({
        //       filesData: res.result.files,
        //     });
        //   },
        //   fail: (error) => {
        //     this.numberOfAjaxCAllPendingDecrease();
        //     this.errorHandler(error);
        //   },
        // });
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
      },
      closeWin: () => {
        this.numberOfAjaxCAllPendingDecrease();
      }
    });
  }
  getFolderPath = () => {
    const { driveName } = this.props
    const folderPath = drivesService.folderPath[driveName]

    if (folderPath) {
      return folderPath
    } else {
      return [
        {
          name: driveName,
          id: null,
        },
      ];
    }
  }
  createFolderPath() {
    let list = [];

    list = this.state.folderPath.map((item, index) => {
      return (
        <Breadcrumb.Item key={index} overlay={item.overlay}>
          <span onClick={this.openFolderFromPath.bind(this, item, index)}>{item.name}</span>
        </Breadcrumb.Item>
      );
    });

    return list;
  }
  createFolderPathForMobile() {
    let list = [];

    list = this.state.folderPath.map((item, index) => {
      return (
        <Breadcrumb.Item key={index}>
          <span onClick={this.openFolderFromPathForMobile.bind(this, item, index)}>{item.name}</span>
        </Breadcrumb.Item>
      );
    });

    return list;
  }
  createDriveIcon(width, height) {
    const { driveName } = this.props;
    let icons = {
      'Google Drive': googleDriveIcon,
      OneDrive: oneDriveIcon,
      DropBox: dropBoxIcon,
      Box: boxIcon,
      [iManage]: IManageIcon,
    };
    store.netDriverStore.drivers.forEach(item=>{
      icons[item.driverName] = item.icon.selected
    });
    const icon = icons[driveName];

    return <img src={icon} alt={driveName} width={width} height={height} />;
  }
  async componentDidMount() {
    const { operateType, customInfo, modalType } = this.props
    const { funType } = store.driveStore

    if (funType === DRIVE_DLG_TYPE_SAVE_AS) {
      const { fileName } = customInfo
      const startIndex = customInfo.fileName.lastIndexOf('.') + 1
      const extension = fileName.substring(startIndex)
      customInfo.fileName.substring()

      iManageService.updateSaveAsExtensionType(extension)
    }

    store.driveStore.updateOperateType(operateType)
    store.driveStore.updateModalType(modalType)
    
    await store.viewer._getPDFUI();
    await this.getPermision();
    if (this.props.visible) {
      await this.init()
    }
    store.appStore.setOpenFileDlgChangeLoadingState((isLoading) => {
      if (isLoading) {
        this.setState({
          numberOfAjaxCAllPending: 1
        })
      } else {
        this.setState({
          numberOfAjaxCAllPending: 0
        })
      }
    });
    !isMobile && this.handleFolderPathOverLen()
  }
  init=async ()=>{
    const { driveName } = this.props

    docName = await fileController.getFileName();
    docName = !!docName ? docName.substring(0, docName.lastIndexOf(".")) : docName;

    let isSignIn = await store.driveStore.isSignInDrive(driveName);
    let filesData;

    if (isSignIn) {
      this.setState({
        isSignIn: true,
      });
      
      this.getDriveModalContentHeight();

      if (this.isIManage()) {
        this.numberOfAjaxCAllPendingIncrease()

        try {
          const filePickerUrl = await iManageService.getFilePickerUrl()
  
          filePickerUrl && this.setState({
            iManageFilePickerUrl: filePickerUrl
          })
        } catch (error) {
          this.resetNumberOfAjaxCAllPending()
          this.errorHandler(error)
        }
      } else {
        this.numberOfAjaxCAllPendingIncrease();
        store.driveStore.doGetUserInfo({
          driveName,
          success: (res) => {
            this.numberOfAjaxCAllPendingDecrease();
            this.setDriveTokenInfo()
            this.setState({
              userInfo: res,
              selectedUser: {
                userAccount: res.userAccount,
                accessToken: res.accessToken
              }
            });
          },
          fail: (error) => {
            this.numberOfAjaxCAllPendingDecrease();
            this.errorHandler(error);
          },
        });

        let folderId = null
        const openedFolder = drivesService.openedFolder[driveName]

        if (openedFolder) {
          folderId = openedFolder.id
        }

        this.numberOfAjaxCAllPendingIncrease();
        await new Promise((resolve, reject) => {
          store.driveStore.doGetItems({
            driveName,
            folderId,
            success: (res) => {
              filesData = res.result.files;
              this.numberOfAjaxCAllPendingDecrease();
              this.setState({
                filesData: res.result.files,
              });
              resolve();
            },
            fail: (error) => {
              this.numberOfAjaxCAllPendingDecrease();
              this.errorHandler(error);
              reject();
            },
          });
        });        
      }
    } else {
      this.setState({
        isSignIn: false,
        filesData: [],
        userInfo: {},
      });
      this.getDriveModalContentHeight();
    }

    const { operateType } = this.props;

    if (this.props.type === 'modal') {
      if (operateType === 'save') {
        !isMobile && (document.getElementsByClassName('ant-modal-body')[0].style.padding = '1px 24px');
        !isMobile && (document.getElementsByClassName('ant-modal-content')[0].style.padding = '0');
        isMobile && (document.getElementsByClassName('ant-modal-body')[0].style.padding = '0');
      } else if (operateType === 'open') {
        !isMobile && (document.getElementsByClassName('ant-modal-body')[0].style.padding = '0 22px 0 22px');
        !isMobile && (document.getElementsByClassName('ant-modal-content')[0].style.padding = '0 0 20px 0');
        isMobile && (document.getElementsByClassName('ant-modal-body')[0].style.padding = '0');
      }
    }
    return filesData;
  }
  getPermision = async () => {
    const { User_Permissions } = window.UIExtension.PDFViewCtrl.PDF.constant;
    const permission = await fileController.getUserPermissions();
    let isEnable = fileController.checkPermission(permission, User_Permissions, CONVERT_PDF_TO_EXCEL);
    const { isDashboardTrial } = store.accountStore;
    this.setState({
      isUseGoogleFormat: isEnable && (await store.userStore.hasSubscribePermission() || isDashboardTrial)
    })
  }
  setDriveTokenInfo = () => {
    const { driveName } = this.props;
    const driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'driveTokenInfo'))

    if (driveTokenInfo) {
      this.setState({
        currentDriveTokenInfo: driveTokenInfo[driveName]
      })
    }
  }
  doDeleteUserToken = (user) => {
    const { driveName } = this.props
    const { currentDriveTokenInfo } = this.state
    const deleteIndex = currentDriveTokenInfo.findIndex((item) => item.userAccount === user.userAccount)

    currentDriveTokenInfo.splice(
      deleteIndex,
      1,
    );

    this.setState({
      currentDriveTokenInfo,
    })
    store.driveStore.doDeleteUserInDriveTokenInfo(driveName, user)
  }
  showDeleteUserConfirm = (okCallback) => {
    const messageDlgCfg = Object.assign({}, this.state.messageDlgCfg, {
      msg: { id: 'DrivesListDlg.RemoveAccount', title: 'PhantomPDF.Online.TitleWithOnline' },
      onOk: () => {
        okCallback && okCallback()
        this.setState({
          isShowMessageDlg: false,
        })
      },
      onClose: () => {
        this.setState({
          isShowMessageDlg: false,
        })
      }
    });

    this.setState({
      isShowMessageDlg: true,
      messageDlgCfg,
    })
  }
  deleteUser = (user, event) => {
    event.stopPropagation()
    this.showDeleteUserConfirm(() => {
      const { selectedUser, currentDriveTokenInfo } = this.state;

      this.doDeleteUserToken(user);

      if (!currentDriveTokenInfo.length) {
        this.signOut();

        return;
      }

      if (user.userAccount === selectedUser.userAccount) {
        this.changeUser(currentDriveTokenInfo[0].userAccount);
      }
    });
  }
  changeUser = (value) => {
    const { driveName } = this.props
    const driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'driveTokenInfo'))[driveName]


    driveTokenInfo.some((item) => {
      if (item.userAccount === value) {
        let ret = store.netDriverStore.GetDriverUserInfo(driveName,item.userAccount)
        if(ret){
          storageSetItem(localStorage, `ext_driver_${driveName}`, JSON.stringify(ret));
        }else{
          storageSetItem(localStorage, driveNameTokenNameMap[driveName], item.accessToken)
        }

        this.setState({
          selectedUser: item,
          filesData: [],
          folderPath: [
            {
              name: driveName,
              id: null,
            },
          ],
        });

        this.numberOfAjaxCAllPendingIncrease();
        store.driveStore.doGetItems({
          driveName,
          folderId: null,
          success: (res) => {
            this.resetNumberOfAjaxCAllPending();
            this.setState({
              filesData: res.result.files,
            });

            // TODO:
          },
          fail: (error) => {
            this.resetNumberOfAjaxCAllPending();
            this.errorHandler(error);
          },
        });

        return true
      }
    }
    )
  }
  // 获取用户信息,如果是ext_driver_开头则是网盘标识,需要单独处理
  getWrapperUserAccount = (userAccount) =>{
    const { driveName } = this.props
    let ret = store.netDriverStore.GetDriverUserInfo(driveName,userAccount)
    if(ret != undefined){
      return ret.title
    }else{
      return userAccount
    }
  }
  returnUserAccountForIManage = () => {
    const { driveName } = this.props
    const userEmail = iManageService.getUserEmail()

    return (
      <Select className={driveName} value={userEmail} style={{ width: 195 }} onChange={this.changeUser} disabled={true}>
        <Option key={0} value={userEmail} className="drive-user-account-menu-item">
          <CloseOutlined style={{ marginRight: '12px' }} />
          {userEmail}
        </Option>
      </Select>
    );
  }
  returnUserAccountMenu = () => {
    const { driveName } = this.props;
    const {
      currentDriveTokenInfo,
      selectedUser: { userAccount },
    } = this.state;

    // 动态插入插件图标样式
    const driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    if (driverId && !this.cache[driverId]) {
      this.cache[driverId] = true;
      const iconUrl = store.netDriverStore.findDriverIcon(driveName);
      const $style = document.body.querySelector('style');
      if ($style != null) {
        $style.sheet.insertRule(`.drives-panel-wrapper .drive-info .${driveName}.ant-select::before{background: url(${iconUrl}) no-repeat 0 0/100% 100%;}`, 0);
      }
    }

    return (
      <Select className={driveName} value={userAccount} style={{ width: 195 }} onChange={this.changeUser}>
        {currentDriveTokenInfo.map((item, index) => {
          return (
            <Option key={index} value={item.userAccount} className="drive-user-account-menu-item">
              <CloseOutlined
                style={{ marginRight: '12px' }}
                onClick={this.deleteUser.bind(this, item)} />
              {this.getWrapperUserAccount(item.userAccount)}
            </Option>
          );
        })}
      </Select>
    );
  }

  componentWillUnmount() {
    store.driveStore.resetSaveType()
    store.driveStore.resetOperateType()
    store.driveStore.resetModalType()
    iManageService.unsubscribeDialogHandler()
    this.tempFolderArr = [];
  }
  getTempFolderArr = () => {
    const { driveName } = this.props
    const tempFolderArr = drivesService.tempFolder[driveName]

    if (tempFolderArr) {
      return tempFolderArr
    }

    return []
  }
  getAllFolderPath() {
    if (this.tempFolderArr.length !== 0) {
      const currentFolderPathLen = this.state.folderPath.length;

      this.state.folderPath.splice(currentFolderPathLen - 1, 0, ...this.tempFolderArr);
    }
  }
  handleFolderPathOverLen() {
    // const this.showFolderNum = 3;
    let folderPathLen = this.state.folderPath.length;
    let overNum = folderPathLen - this.showFolderNum;
    let folderPathLastIndex = folderPathLen - 1;
    const { driveName } = this.props

    if (folderPathLen > this.showFolderNum) {
      let dropdownFolder;
      let folderArr = [...this.state.folderPath];
      const startIndex = folderPathLastIndex - overNum;
      const deleteNum = folderPathLen - this.showFolderNum;

      this.tempFolderArr = folderArr.splice(startIndex, deleteNum);
      drivesService.updateTempFolder({[driveName]: this.tempFolderArr})
      
      dropdownFolder = (
        <React.Fragment>
          <Menu className="drives-folder-path">
            {this.tempFolderArr.map((item, index) => {
              return (
                <Menu.Item key={index}>
                  <span onClick={this.openFolderFromPath.bind(this, item, index)}>{item.name}</span>
                </Menu.Item>
              );
            })}
          </Menu>
        </React.Fragment>
      );

      folderArr.forEach((item, index) => {
        const targetIndex = folderArr.length - 2;

        if (index === targetIndex) {
          item.overlay = dropdownFolder;
        } else {
          item.overlay = null;
        }
      });

      this.setState({
        folderPath: folderArr,
      });
      // this.state.folderPath = folderArr;
    } else {
      let tempArr = [...this.state.folderPath];

      tempArr.forEach((item) => {
        item.overlay = false;
      });

      this.setState({
        folderPath: tempArr,
      });
      // this.state.folderPath = tempArr;

      this.tempFolderArr = [];
    }
  }
  async getCurrentPDFBlob({ fileName, /* mimeType */ }) {
    try {
      this.setState({
        loadingDocBuffer: true,
      });

      const docFileName = fileName || (await fileController.getFileName());
      const fileBuffer = (await fileController.getCurrentDocBuffer())[0];
      const fileType = 'application/pdf';
      let blob = new Blob(fileBuffer, { type: fileType });

      blob.name = docFileName;

      this.setState({
        loadingDocBuffer: false,
      });

      return blob;
    } catch (error) {
      this.setState({
        loadingDocBuffer: false,
      });
    }
  }
  async doUpdateFile(record,callback) {
    const { customInfo } = this.props;

    this.numberOfAjaxCAllPendingIncrease();

    let fileBlob;
    if (customInfo && customInfo.getFileInfo) {
      const fileInfo = await customInfo.getFileInfo();
      if (!fileInfo) {
        this.numberOfAjaxCAllPendingDecrease();
        return;
      }
      fileInfo.blob.name = record.name || fileInfo.fileName;
      fileBlob = fileInfo.blob;
      record.mimeType = fileInfo.mimeType;
      record.fileType = fileInfo.fileType;
    } else {
      fileBlob = await this.getCurrentPDFBlob({ fileName: record.name, mimeType: record.mimeType });
    }

    if (fileBlob.size > 1024 * 1024 * DRIVES_FILE_SIZE_LIMIT) {
      message.error(intl.formatMessage({ id: 'FileOverSize' }));
      this.numberOfAjaxCAllPendingDecrease();
      return;
    }

    this.numberOfAjaxCAllPendingIncrease();
    store.driveStore.doUpdateFile({
      driveName: this.props.driveName,
      record,
      fileBlob,
      success: () => {
        this.props.saveSucceedCallback && this.props.saveSucceedCallback(true);
        this.numberOfAjaxCAllPendingDecrease();
        this.refreshFolder(this.state.folderPath[this.state.folderPath.length - 1], () => {
          this.props.cancelModal();
        });
        callback && callback('success');
        // store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'UploadingFile.success' }) });
      },
      fail: (error) => {
        this.numberOfAjaxCAllPendingDecrease();
        this.errorHandler(error);
        callback && callback(error)
        // store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'UploadingFile.fail' }) });
      },
    });
  }
  getCurrentFolder = () => {
    const currentFolder = [...this.state.folderPath].reverse()[0]

    return currentFolder
  }
  getCurrentFolderId = () => {
    const currentFolder = this.getCurrentFolder()

    return currentFolder.id
  }
  async doSaveFile(fileName, mimeType, fileType, callback, libraryName, folderId, doc_profile) {
    const { customInfo, driveName } = this.props;
    this.setState({uploading:true})
    let fileBlob;

    const Fn = async () => {
      if (fileBlob.size > 1024 * 1024 * DRIVES_FILE_SIZE_LIMIT) {
        message.error(intl.formatMessage({ id: 'FileOverSize' }));
        this.numberOfAjaxCAllPendingDecrease();
        return;
      }
      const { docInfo } = store.docStore;
      docInfo.fileName = fileName;

      if (!this.isIManage()) {
        this.getAllFolderPath()
        const folderPath = this.state.folderPath;
        store.driveStore.doCreateFile({
          driveName,
          fileBlob,
          folderPath,
          mimeType,
          fileType,
          success: () => {
            this.props.saveSucceedCallback && this.props.saveSucceedCallback(true);
            this.numberOfAjaxCAllPendingDecrease();
            this.refreshFolder(this.state.folderPath[this.state.folderPath.length - 1], () => {
              this.props.cancelModal();
            });
            callback && callback('success');
            store.appStore.setGlobalMessage({
              type: 'success',
              content: intl.formatMessage({ id: 'UploadingFile.success' })
            });
            this.setState({uploading:false})
            store.docStore.setDocDriveName(this.props.driveName);
            store.docStore.setDocInfo(docInfo);
          },
          fail: (error) => {
            this.numberOfAjaxCAllPendingDecrease();
            this.errorHandler(error);
            callback && callback(error);
            if (error.errorMsg != undefined && error.errorMsg != "")
              store.appStore.setGlobalMessage({ type: 'error', content: error.errorMsg});
            else{
              store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'UploadingFile.fail' }) });
            }
          },
        });
      } else {
        try {
          const res = await store.driveStore.doCreateFile({
            driveName,
            fileBlob,
            libraryName,
            folderId,
            doc_profile
          })
  
          if (res.httpCode === 201) {
            store.appStore.setGlobalMessage({type: 'success', content: intl.get('UploadingFile.success')})
            store.docStore.setDocDriveName(this.props.driveName);
            store.docStore.setDocInfo(docInfo);
          } else {
            throw 'create file failed'
          }
        } catch (error) {
          store.appStore.setGlobalMessage({type: 'error', content: intl.get('UploadingFile.fail')})
          
          console.error(error);
        }

        localToGlobal.onCloseSaveFilePanel()
        store.appStore.doUpdateDocModified(false)
      }
    };

    this.numberOfAjaxCAllPendingIncrease();
    if (customInfo && customInfo.getFileInfo) {
      const fileInfo = await customInfo.getFileInfo();
      if (!fileInfo) {
        this.numberOfAjaxCAllPendingDecrease();
        return;
      }
      fileInfo.blob.name = fileName || fileInfo.fileName;
      fileBlob = fileInfo.blob;
      mimeType = fileInfo.mimeType;
      fileType = fileInfo.fileType;
      Fn();
    } else {
      if (fileType === 'gsheet' || fileType === 'gslides') {//gsheet,gslides 格式需要转换为xlsx，pptx 上传至google网盘
        let convertType, downloadType;
        if (fileType === 'gsheet') {
          convertType = CONVERT_PDF_TO_EXCEL;
          downloadType = '.xlsx';
        }
        if (fileType === 'gslides') {
          convertType = CONVERT_PDF_TO_PPT;
          downloadType = '.pptx';
        }
        this.setState({
          loadingDocBuffer: true,
        });
        convertController.doConvertPDFFile_noTips(convertType, (result) => {
          if (result.status === TASK_STATUS.FINISH) {
            let fileUrl = fileName ? result.url.replace('filename=stream', 'filename=' + encodeURIComponent(fileName) + downloadType) : result.url;
            getFileBufferByUrl(fileUrl, (res) => {
              fileBlob = res;
              fileBlob.name = fileName;
              this.setState({
                loadingDocBuffer: false,
              });
              Fn();
            });
          }
        }, (/*err*/) => {});
      } else {
        fileBlob = await this.getCurrentPDFBlob({ fileName, mimeType });
        Fn();
      }
    }
  }
  getMimeType = (fileType) => {
    let type;
    switch (fileType) {
      case 'pdf':
        type = 'application/pdf';
        break;
      case 'gdoc':
        type = 'application/vnd.google-apps.document';
        break;
      case 'gsheet':
        type = 'application/vnd.google-apps.spreadsheet';
        break;
      case 'gslides':
        type = 'application/vnd.google-apps.presentation';
        break;
      default:
        type = 'application/pdf';
        break;
    }
    return type;
  };
  onSaveFile(e) {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { filename, fileType } = values;

        const regExpFileName = /^#|[\\/:*?<>|]+/;
        if (regExpFileName.test(filename)) {
          store.appStore.setGlobalMessage({ type: 'error', content: this.SpecialCharacters });
          return;
        }

        let fileIdForGoogle;
        let duplicateFileName = this.state.filesData.some((item) => {
          if (handlerFileNameWithoutExtension(filename).toLowerCase() === item.name.toLowerCase()) {
            item.id && (fileIdForGoogle = item.id);
            return true;
          }
          return false;
        });
        const mimeType = this.getMimeType(fileType);

        if (duplicateFileName) {
          const { driveName } = this.props;
          let record = {
            filename: filename,
            id: fileIdForGoogle,
            mimeType,
            fileType
          };
          const messageDlgCfg = Object.assign({}, this.state.messageDlgCfg, {
            msg: {
              id: 'Private.duplicateFileNameContent',
              messageParams: { FileName: handlerFileNameWithoutExtension(filename) },
              title: 'Private.duplicateFileNameTitle',
              ok: 'Save',
              cancel: 'Cancel',
            },
            onOk: () => {
              if (driveName === 'Google Drive' || driveName === 'Box') {
                this.doUpdateFile(record,(result)=>{
                  if(result != 'success'){
                    store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'UploadingFile.fail' }) });
                  }else{
                    store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'UploadingFile.success' }) });
                    store.docStore.setDocDriveName(this.props.driveName);
                  }
                });
              } else {
                this.doSaveFile(filename, mimeType, fileType);
              }
              this.setState({
                isShowMessageDlg: false,
              });
            },
            onClose: () => {
              this.setState({
                isShowMessageDlg: false,
              });
            },
          });

          this.setState({
            isShowMessageDlg: true,
            messageDlgCfg,
          })
        } else {
          this.doSaveFile(filename, mimeType, fileType);
        }
      }
    });
  }
  onSaveFileByMyself= async (callback)=>{//原文档名直接保存至网盘
        const filesData = await this.init();
        const filename = store.docStore.docInfo.fileName;
        const fileType = 'pdf'
        let fileIdForGoogle;
        let duplicateFileName = (filesData || this.state.filesData).some((item) => {
          if (handlerFileNameWithoutExtension(filename).toLowerCase() === item.name.toLowerCase()) {
            item.id && (fileIdForGoogle = item.id);
            return true;
          }
          return false;
        });
        const mimeType = this.getMimeType(fileType);
        if (duplicateFileName) {
          // const { driveName }  = store.driveStore;
          const driveName = store.driveStore.driveName || store.docStore.docDriveName;
          let record = {
            filename: filename,
            id: fileIdForGoogle,
            mimeType,
            fileType
          };
          if (driveName === 'Google Drive' || driveName === 'Box') {
            this.doUpdateFile(record,(result)=>{
              callback && callback(result)

              if(result != 'success'){
                store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'SaveFile.fail' }) });
              }else{
                store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'SaveFile.success' }) });
              }
            });
          } else {
            this.doSaveFile(filename, mimeType, fileType,callback);
          }
        } else {
          this.doSaveFile(filename, mimeType, fileType,callback);
        }
  }
  getSaveFileInputPanel() {
    let result = null;
    const save = intl.formatMessage({ id: 'Save' });
    // const fileNameRequire = intl.formatMessage({ id: 'PrivateDrive.FileNameRequire' });
    const fileName = intl.formatMessage({ id: 'PrivateDrive.FileName' });
    const { getFieldDecorator } = this.props.form;
    const { operateType, openFileInfo } = this.props;
    const { isSignIn } = this.state;
    // const isSignIn = this.isSignIn();
    // const { showSignInPanel, operateType, openedFileInfo, } = store.driveStore;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };

    if (isSignIn && operateType === 'save') {
      result = (
        <React.Fragment>
          <Form {...formItemLayout} onSubmit={this.onSaveFile} labelAlign="left" className="save-input-panel">
            <Form.Item label={fileName}>
              {getFieldDecorator('filename', {
                initialValue: docName || (openFileInfo && openFileInfo.item && openFileInfo.item.name),
                rules: [
                  {
                    required: true,
                    message: this.FileNameRequire,
                  },
                ],
              })(<Input type="text" />)}
            </Form.Item>
            <Form.Item wrapperCol={{ xs: { span: 24 }, sm: { span: 24 } }}>
              <div style={{ textAlign: 'right' }}>
                <Button htmlType="submit">{save}</Button>
              </div>
            </Form.Item>
          </Form>
        </React.Fragment>
      );
    }

    return result;
  }
  errorHandler(error) {
    if (error && error.autoSignOut) {
      this.setState({
        isSignIn: false,
        filesData: [],
        userInfo: {},
        driveModalContentHeight: isMobile ? this.defaultModalContentHeightForMobile : this.defaultModalContentHeight,
      });
    }

    if(error && error.errorMsg && error.errorMsg != ""){
      // 外部网盘插件报错提示
      store.appStore.setGlobalMessage({ type: 'error', content: error.errorMsg});
    }
    // switch (this.props.driveName) {
    //   case 'Google Drive':
    //     break;
    //   case 'OneDrive':
    //     break;
    //   case 'DropBox':
    //     break;
    //   default:
    //     break;
    // }
  }
  cancelDrivesModal() {
    // const { driveName } = store.driveStore;
    const { driveName, type } = this.props;
    const isDownloadingFile = store.driveStore.isDownloadFilePending(driveName);
    const isUploadingFile = store.driveStore.isUploadFilePending(driveName);
    const isUpdatingFile = store.driveStore.isUpdateFilePending(driveName);
    const _handlerDriveStore = () => {
      this.setState({
        isSignIn: false,
        filesData: [],
        userInfo: {},
        numberOfAjaxCAllPending: 0,
      });
      this.getDriveModalContentHeight();
      type === 'modal' && this.props.cancelModal();
    };

    if (isDownloadingFile) {
      const messageDlgCfg = Object.assign({}, this.state.messageDlgCfg, {
        msg: { id: '', title: 'OpenFilePending' },
        onOk: () => {
          store.driveStore.doCancelOpenFileRequest(this.props.driveName);
          _handlerDriveStore();
          this.setState({
            isShowMessageDlg: false,
          })
        },
        onClose: () => {
          this.setState({
            isShowMessageDlg: false,
          })
        }
      });

      this.setState({
        isShowMessageDlg: true,
        messageDlgCfg,
      })
    } else if (isUploadingFile || isUpdatingFile) {
      const messageDlgCfg = Object.assign({}, this.state.messageDlgCfg, {
        msg: { id: '', title: 'SaveFilePending' },
        onOk: () => {
          isUploadingFile ? store.driveStore.doCancelUploadFileRequest(this.props.driveName) : store.driveStore.doCancelUpdateFileRequest(this.props.driveName);
          _handlerDriveStore();
          this.setState({
            isShowMessageDlg: false,
          })
        },
        onClose: () => {
          this.setState({
            isShowMessageDlg: false,
          })
        }
      });

      this.setState({
        isShowMessageDlg: true,
        messageDlgCfg,
      })
    } else {
      _handlerDriveStore();
    }
  }
  onAddFiles(selectedFileArr) {
    const targetSelectedFiles = selectedFileArr || this.state.selectedRows
    const filesList = [];
    const taskCreateSuccess = (result) => {
      store.appStore.emitEvent('addFilesForCombine', result);
      // store.appStore.setGlobalMessage({ type: 'success', content: this.AddFilesSuccess });
      this.props.previousStep();
    };


    let hasOverSizeFile = targetSelectedFiles.some((item) => {
      const sizeNum = Number(item.size.substring(0, item.size.length - 2));
      const sizeUnit = item.size.substring(item.size.length - 2);

      if (sizeUnit === 'MB' && sizeNum / 1024 > 1) {
        return true;
      } else {
        const fileData = new FileData({ driveName: this.props.driveName, item }, item.name, DATA_TYPE.Cloud, '', item.id);

        filesList.push(fileData);
      }
    });

    if (hasOverSizeFile) {
      store.appStore.setGlobalMessage({ type: 'error', content: this.SingleFileSizeOver });

      return;
    }

    // TODO: 此处添加task任务
    const taskList = store.taskStore.doUploadMultiFiles(filesList, (result) => {
      // {ret :1, msg :'Error.UploadingFile.fail', list:[{id:fileUid,taskId:taskUpload.id}]}
      const { ret, msg, list } = result;

      if (ret === 1 && msg === 'Error.UploadingFile.fail') {
        this.props.onUploadFileFailedCallback(list);
      }
    });

    if (taskList.length === 0) {
      return;
    }

    taskList.forEach((item) => {
      filesList.some((innerItem) => {
        const { id, name, modifiedTime, size } = innerItem.file.item;

        if (item.id === id) {
          // item.id = `${item.id}-${new Date().getTime()}`;
          item.name = name;
          item.modifiedTime = modifiedTime.substring(0, 10);
          item.size = size;
          item.cuid = cuid()
          item.bookmark = name;
          item.range = 'ALL';

          return true;
        }
      });
    });
    taskCreateSuccess(taskList);
  }
  onOpen() {
    const { isFolder, id } = this.state.activeRow;
    const { openFileDlg: { isForAi } } = store.appStore

    if (id && !isFolder) {
      if (isForAi) {
        this.doUploadFileForAi(this.state.activeRow)
      } else {
        this.downloadFile(this.state.activeRow);
      }
    } else if (id && isFolder) {
      this.openFolder(this.state.activeRow);
    }
  }
  doUploadFileForAi = (activeRow) => {
    const files = []
    const { id: account_id, userAccount } = this.state.userInfo
    const { driveName: drive } = store.driveStore;
    const { id: fileId, name, originSize } = activeRow
    const { openFileDlg: { resolveFileListToAiPlugin } } = store.appStore

    files.push({
      id: fileId,
      '@microsoft.graph.downloadUrl': activeRow['@microsoft.graph.downloadUrl'],
      name,
      size: parseFloat(originSize),
      drive,
      account_id,
      account: userAccount,
    })

    resolveFileListToAiPlugin(files);
  }
  onChangeFileType = (value) => {
    this.setState({
      selectedFileType: value
    })
  }
  fileTypeChange = (value) => {
    let selectedFileType = this.getSelectedFileType(value);
    this.setState({
      fileType: value,
      selectedFileType
    })
  }
  getSelectedFileType = (value) => {
    let selectedFileType = '';
    switch (value) {
      case 'pdf':
        selectedFileType = 'PDF';
        break;
      case 'gdoc':
        selectedFileType = 'Gdoc';
        break;
      case 'gsheet':
        selectedFileType = 'Gsheet';
        break;
      case 'gslides':
        selectedFileType = 'Gslides';
        break;
      default:
        selectedFileType = 'PDF';
    }
    return selectedFileType
  }
  getPanelTypeFooterBtnWrapper() {
    const { isSignIn, /* activeRow, */ fileType, isUseGoogleFormat } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { /* operateType, */ openFileInfo, customInfo } = this.props;
    const initialValue = (customInfo && customInfo.fileName) || docName || (openFileInfo && openFileInfo.item && openFileInfo.item.name);
    const fileTypeOption = (!isUseGoogleFormat) ? (<Select style={{ width: 220 }} getPopupContainer={triggerNode => triggerNode.parentElement} onChange={this.fileTypeChange}>
      <Option value="pdf">PDF(*.pdf;*.ppdf)</Option>
    </Select>) : (
      <Select style={{ width: 220 }} getPopupContainer={triggerNode => triggerNode.parentElement} onChange={this.fileTypeChange}>
        <Option value="pdf">PDF(*.pdf;*.ppdf)</Option>
        <Option value="gdoc">Google Docs(*.gdoc)</Option>
        <Option value="gsheet">Google Sheets(*.gheet)</Option>
        <Option value="gslides">Google slides(*.gslides)</Option>
      </Select>);

    const footerBtnStyle = {
      height: '24px',
      padding: '0 20px',
      fontSize: '14px',
      borderRadius: '24px'
    };
    // const openFooter = (
    //   <div className="panel-type-footer-wrapper">
    //     <Button disabled={JSON.stringify(activeRow) === '{}'} onClick={this.onOpen} className="m-r-20" type="primary">
    //       {this.Open}
    //     </Button>
    //     <Button onClick={this.props.onCancel} className="m-r-10">
    //       {this.Cancel}
    //     </Button>
    //   </div>
    // );
    const saveFooter = (
      <div className="panel-type-footer-wrapper flex-between">
        <div>
          <span className="file-name">{`${this.FileName}:`}</span>
          {getFieldDecorator('filename', {
            initialValue,
            rules: [
              {
                required: true,
                message: this.FileNameRequire,
              },
            ],
          })(<Input className="file-name-input"/>)}
        </div>
        <div>
          <Button type='primary' onClick={this.onSaveFile} className="save-btn">
            {this.Save}
          </Button>
          <Button onClick={this.props.onCancel} className="m-r-20">
            {this.Cancel}
          </Button>
        </div>
      </div>
    );
    const saveGoogleFooter = (
      <div className="panel-type-footer-wrapper GoogleFooter ">
        <div className="wrap_input">
          <div className="wrap_filename">
            <span className="file-name">{`${this.FileName}:`}</span>
            {getFieldDecorator('filename', {
              initialValue,
              rules: [
                {
                  required: true,
                  message: this.FileNameRequire,
                },
              ],
            })(<Input className="file-name-input"/>)}
          </div>
          {
            !customInfo &&
            <div className="wrap_fileType">
              <span className="file-type">{`${this.FileType}:`}</span>
              {getFieldDecorator('fileType', {
                initialValue: 'pdf',
                value: fileType
              })(
              fileTypeOption
              )}
            </div>
          }
        </div>
        <div className="wrap_buttons">
          <Button type="primary" onClick={this.onSaveFile} className="m-r-20 save-btn">
            {this.Save}
          </Button>
          <Button onClick={this.props.onCancel} className="m-r-10">
            {this.Cancel}
          </Button>
        </div>
      </div>
    );

    const addFooter = isSignIn ? (
      <div className="panel-type-footer-wrapper" style={{ transform: 'translate(0, 20px)', border: 'none', alignItems: 'flex-end' }}>
        <Button type="primary" style={footerBtnStyle} shape="round" className="m-r-10" onClick={this.onAddFiles.bind(this, null)}>
          {this.AddFile}
        </Button>
        <Button style={footerBtnStyle} shape="round" className="m-r-20" onClick={this.props.previousStep}>
          {this.Cancel}
        </Button>
      </div>
    ) : (<></>);

    if (isSignIn && this.props.operateType === 'open') {
      return null;
      // return openFooter;
    }
    if (isSignIn && this.props.operateType === 'save') {
      if (this.props.driveName === GOOGLE_DRIVE) {
        return saveGoogleFooter;
      }
      return saveFooter;
    }
    if (this.props.operateType === 'add') {
      return addFooter;
    }
  }
  filterFileByFileType = (fileType) => {
    let fileExtensions = SUPPORT_FILE_EXTENSIONS_MAP[fileType];

    if (fileExtensions.length === 0) {
      return this.state.filesData;
    } else {
      return this.state.filesData.filter((item) => {
        const itemExtension = item.name.replace(/.+\./, '');

        if (fileExtensions.indexOf(itemExtension) > -1 || item.isFolder) {
          return true;
        }
      });
    }
  }
  filterFileForMultiConvert(filesData) {
    let showData = toJS(filesData);
    let { driveName, modalType, operateType } = this.props;
    if (driveName && modalType === 'convert' && operateType === 'add') {
      if (showData.length) {
        showData = showData.filter(({ isFolder, name}) => {
          if (isFolder) {
            return true;
          }
          return getExtensionByFileName(name) !== '.pdf';
        }) 
      }
    }
    return showData;
  }
  selectRow = (record) => {
    if (record.isFolder) {
      return
    }

    const selectedRowKeys = [...this.state.selectedRowKeys];
    const selectedRows = [...this.state.selectedRows];

    if (selectedRowKeys.indexOf(record.id) >= 0) {
      selectedRowKeys.splice(selectedRowKeys.indexOf(record.id), 1);
      selectedRows.some((item, index) => {
        if (item.id === record.id) {
          selectedRows.splice(index, 1)
          return true
        }
      }
      )
    } else {
      selectedRowKeys.push(record.id);
      selectedRows.push(record)
    }

    this.setState({ selectedRowKeys, selectedRows, });
  }

  isIManage() {
    const { driveName } = this.props

    return driveName === iManage
  }
  iManageFrameOnLoad = () => {
    this.resetNumberOfAjaxCAllPending()
  }
  iManageFrameOnError = () => {
    this.resetNumberOfAjaxCAllPending()
  }
  reloadIManageFrame = async () => {
    try {
      this.numberOfAjaxCAllPendingIncrease();

      const filePickerUrl = await iManageService.getFilePickerUrl();
  
      this.resetNumberOfAjaxCAllPending();
      filePickerUrl && this.setState({
        iManageFilePickerUrl: filePickerUrl,
      });
    } catch (error) {
      this.resetNumberOfAjaxCAllPending()
    }
  }
  render() {
    const { selectedFileType, messageDlgCfg, isShowMessageDlg, selectedRowKeys, iManageFilePickerUrl, isSignIn } = this.state
    const { operateType, driveName } = this.props;
    const openFile = intl.formatMessage({ id: 'OpenFile' });
    const saveFile = intl.formatMessage({ id: 'SaveFile' });
    const signInTo = intl.formatMessage({ id: 'SignInTo' }, { DriveName: this.props.driveName });
    const signInToYour = intl.formatMessage({ id: 'SignInToYour' }, { DriveName: this.props.driveName });
    // const msg = intl.formatMessage({ id: 'SelectHost' });
    const signOut = intl.formatMessage({ id: 'PrivateDrive.signOut' });
    const filesData = this.filterFileByFileType(selectedFileType)
    let showData = this.filterFileForMultiConvert(filesData);
    const userAccountMenu = this.returnUserAccountMenu()
    const rowSelection = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedRowKeys,
          selectedRows,
        });

      },
      getCheckboxProps: (record) => ({
        disabled: record.isFolder, // Column configuration not to be checked
        name: record.name,
      }),
    };
    // const host = intl.formatMessage({ id: 'Host' });
    // const share = intl.formatMessage({ id: 'Share' });
    // const userName = intl.formatMessage({ id: 'UserName' });
    // const password = intl.formatMessage({ id: 'Password' });
    // const cancel = intl.formatMessage({ id: 'Cancel' });
    // const connect = intl.formatMessage({ id: 'Connect' });
    const getContentWrapperStyle = () => {
      if (this.props.type === 'panel') {
        if (operateType === 'open' || driveName === iManage) {
          return { height: 'calc(100% - 24px)', position: 'relative' }
        }
        return { height: 'calc(100% - 74px)', position: 'relative' };
      }
      if (this.props.type === 'panel' && operateType !== 'add') {
        return { height: 'calc(100% - 54px)', position: 'relative' };
        // if (operateType === 'open' || operateType === 'add') {
        //   return { height: 'calc(100% - 54px)', position: 'relative' };
        // } else if (operateType === 'save') {
        //   return { height: 'calc(100% - 88px)', position: 'relative' };
        // }
      } else if (this.props.type === 'panel' && operateType === 'add') {
        const retStyle = {
          position: 'relative',
          background: '#f1f1f1',
          borderRadius: '5px',
          margin: '0 24px 0 24px',
        };
        if (isSignIn) {
          return {
            ...retStyle,
            paddingTop: '15px',
            paddingBottom: '23px'
          };
        } else {
          return retStyle;
        }
      }else if (this.props.type === 'modal') {
        return { height: this.state.driveModalContentHeight };
      }
    };
    const getFileTableHeight = () => {
      if (operateType === 'open') {
        return 468
      } else if (operateType === 'save') {
        return 418
      } else {
        return 324
      }
    }
    const contentWrapperDOM = () => (
      <Spin tip={intl.formatMessage({id:this.state.uploading?'Uploading': 'Loading.file'})} spinning={this.state.numberOfAjaxCAllPending !== 0 || this.state.loadingDocBuffer}>
        <div style={getContentWrapperStyle()} className="content-wrapper">
          {!isSignIn && (
            <React.Fragment>
              <div className="t-center sign-in-modal">
                <div className="icon-wrapper">{this.createDriveIcon(driveIconSize.width, driveIconSize.height)}</div>
                <div className="content">{`${signInToYour}`}</div>
                <div className="sign-in-btn-wrapper">
                  <Button className="sign-in-btn" type="primary" onClick={this.authorization}>{`${signInTo}`}</Button>
                </div>
              </div>
            </React.Fragment>
          )}
          {isSignIn && (
            <div className="drive-info">
              {!this.isIManage() && userAccountMenu}
              {this.isIManage() && this.returnUserAccountForIManage()}
              <div style={{ float: 'right' }}>
                {operateType === 'save' && !this.isIManage() &&
                  <Tooltip title={intl.get('SaveFileForPanel.Modal.NewFolder')}>
                    <i className="create-folder-btn icon" onClick={this.createFolder} />
                  </Tooltip>
                }
                {!this.isIManage() && <Tooltip title={intl.get('SaveFileForPanel.Modal.AddUser')}>
                  <i className="add-user-btn icon" onClick={this.authorization} />
                </Tooltip>}
                <Tooltip title={intl.get('SaveFileForPanel.Modal.RefreshFolder')}>
                  {!this.isIManage() && <img
                    src={refreshBtnIcon}
                    onClick={this.refreshFolder.bind(this, this.state.folderPath[this.state.folderPath.length - 1], null)}
                    className="refresh-folder-btn"
                    alt="refresh"
                  />}
                  {this.isIManage() && <img
                    src={refreshBtnIcon}
                    onClick={this.reloadIManageFrame.bind(this)}
                    className="refresh-folder-btn"
                    alt="refresh"
                  />}
                </Tooltip>
                <Tooltip title={intl.get('SaveFileForPanel.Modal.SignOut')}>
                  <i className="exit-btn icon" onClick={this.signOut}>
                    {/* {signOut} */}
                  </i>
                </Tooltip>
              </div>
              <div style={{ clear: 'both' }}></div>
            </div>
          )}
          {isSignIn && this.isIManage() && (
            <React.Fragment>
              <iframe
                ref={this.iManageFrameRef}
                className="imanage-frame"
                onLoad={this.iManageFrameOnLoad}
                onError={this.iManageFrameOnError}
                src={iManageFilePickerUrl}/>
          </React.Fragment>
          )}
          {isSignIn && (!this.isIManage() && 
            <React.Fragment>
              <div
                {...{
                  style: operateType === 'add' ? {
                    marginTop: '0',
                    border: '1px solid #dddddd',
                    background: '#fff'
                  } : {}
                }}
                className="drive-list-wrapper"
              >
                <div
                  {...{
                    style: operateType === 'add' ? {
                      paddingLeft: '23px',
                      background: 'white'
                    } : {}
                  }}
                  className="folder-path-wrapper"
                >
                  <Breadcrumb separator=">">{isSignIn && this.createFolderPath()}</Breadcrumb>
                </div>
                <div className="files-table-wrapper">
                  <Table
                    className="online-purple-table"
                    rowKey="id"
                    rowSelection={operateType === 'add' ? rowSelection : null}
                    onRow={
                      operateType === 'add'
                        // selectedRowKeys, selectedRows
                        ? (record) => ({
                          onClick: () => {
                            this.selectRow(record);
                          }
                        })
                        : null
                    }
                    columns={this.createTableColumn()}
                    dataSource={showData}
                    pagination={false}
                    scroll={{ y: Number(getFileTableHeight()) }}
                  />
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        {this.props.type === 'panel' && this.getPanelTypeFooterBtnWrapper()}
        <div>{this.props.type === 'modal' && this.getSaveFileInputPanel()}</div>
      </Spin>
    );
    const wrapperDOMForPC = () => {
      if (this.props.type === 'panel') {
        return <div className={`drives-panel-wrapper drives-content-wrapper ${driveName}`}>{contentWrapperDOM()}</div>;
      } else if (this.props.type === 'modal') {
        return (
          <Modal
            title={operateType === 'open' ? openFile : saveFile}
            width="565px"
            className="drives-modal drives-content-wrapper"
            visible={this.props.visible}
            onCancel={this.cancelDrivesModal}
            centered={true}
            footer={null}
            maskClosable={false}>
            {contentWrapperDOM()}
          </Modal>
        );
      }
    };

    return this.props.visible ? (
      <React.Fragment>
        {!isMobile && wrapperDOMForPC()}
        {isMobile && (
          <Modal
            title={driveName}
            className={`drives-modal drives-content-wrapper ${driveName}`}
            mask={false}
            visible={this.props.visible}
            onCancel={this.cancelDrivesModal}
            footer={null}
            centered={false}
            maskClosable={false}>
            <Spin tip={intl.formatMessage({id:this.state.uploading?'Uploading': 'Loading.file'})} spinning={this.state.numberOfAjaxCAllPending !== 0 || this.state.loadingDocBuffer}>
              <div style={{ height: this.state.driveModalContentHeight }} className="content-wrapper">
                {!isSignIn && (
                  <React.Fragment>
                    <div className="t-center sign-in-modal">
                      <div style={{ paddingTop: '100px' }}>{this.createDriveIcon('56px', 'auto')}</div>
                      <div style={{ marginTop: '20px' }}>
                        <p>{`Sign in to your ${driveName} to`}</p>
                        <p>access your documents</p>
                      </div>
                      <div style={{ marginTop: '25px' }}>
                        <Button
                          onClick={this.authorization}
                          style={{ width: '145px', height: '35px', padding: '0' }}>{`Sign in to ${driveName}`}</Button>
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {isSignIn && (
                  <React.Fragment>
                    <div className="drive-list-wrapper">
                      <div className="folder-path-wrapper">
                        <Breadcrumb separator=">">{isSignIn && this.createFolderPathForMobile()}</Breadcrumb>
                      </div>
                      <div className="files-table-wrapper">
                        <Table
                          // className="online-purple-table"
                          rowKey="id"
                          columns={this.createTableColumn()}
                          dataSource={showData}
                          pagination={false}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
              {isSignIn && operateType === 'open' && (
                <div className="sign-out-btn-wrapper">
                  <span className="p-r-10">{this.state.userInfo.userAccount}</span>
                  <Button onClick={this.signOut}>
                    {signOut}
                  </Button>
                </div>
              )}
              <div style={{ padding: '0 10px' }}>{this.getSaveFileInputPanel()}</div>
            </Spin>
          </Modal>
        )}
        {isShowMessageDlg && <MessageDialog {...messageDlgCfg} visible={true} />}
      </React.Fragment>
    ) : null;
  }
}

const WrappedDrives = Form.create({ name: 'register' })(Drives);

export default WrappedDrives;
